import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, ArrowRight, Frame as FrameIcon } from "lucide-react";

export default function Frames() {
  const [frames, setFrames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/frames")
      .then((r) => setFrames(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-28 pb-24 px-6 lg:px-10 relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="overline text-gold">Teuralink Framed Prints</div>
          <h1 className="font-display text-4xl lg:text-6xl font-bold tracking-tight mt-3">
            Cosmic Frames <span className="text-gold">.</span>
          </h1>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">
            Hand-finished planetary posters in premium wooden frames. A daily reminder
            of the cosmos on your wall — every piece at a flat <span className="text-gold font-mono-space">₹499</span>.
          </p>
        </div>

        {loading ? (
          <div className="mt-24 flex justify-center">
            <Loader2 className="w-6 h-6 animate-spin text-gold" />
          </div>
        ) : (
          <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="frames-grid">
            {frames.map((f) => (
              <Link
                key={f.id}
                to={`/frames/${f.id}`}
                data-testid={`frame-card-${f.id}`}
                className="group glass rounded-3xl p-4 hover:border-[#D4AF37]/40 transition-all"
              >
                <div className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-black/40">
                  <img
                    src={f.image_url}
                    alt={`Teuralink ${f.planet} framed print`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  <div className="absolute top-3 right-3 bg-black/70 backdrop-blur px-3 py-1.5 rounded-full text-xs font-mono-space text-gold border border-[#D4AF37]/30">
                    ₹{f.price_inr}
                  </div>
                </div>
                <div className="mt-5 px-2 pb-2">
                  <div className="overline text-white/50">Framed Print</div>
                  <div className="font-display text-2xl font-bold tracking-tight mt-1">{f.planet}</div>
                  <p className="text-sm text-white/60 mt-2 line-clamp-2">{f.quote}</p>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="font-mono-space text-lg text-gold">₹{f.price_inr}</span>
                    <span className="btn-ghost !py-1.5 !px-3 text-xs group-hover:bg-white/[0.08]">
                      <FrameIcon className="w-3.5 h-3.5" /> View & Buy <ArrowRight className="w-3 h-3" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="mt-16 text-center text-xs text-white/45 max-w-lg mx-auto">
          Ships across India within 5–7 business days. Every frame is hand-inspected before dispatch.
        </div>
      </div>
    </div>
  );
}
